"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.text = void 0;
const slickgrid_1 = require("slickgrid");
function text() {
    return slickgrid_1.Editors.Text;
}
exports.text = text;
//# sourceMappingURL=editors.js.map